// extracted by mini-css-extract-plugin
module.exports = {"cite":"cite-module--cite--20sDI"};